// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"SwitchablePicker_custom_select__2QF0d","custom_date_picker":"SwitchablePicker_custom_date_picker__2jGEL"};